import { metamaskErrorToast } from "@/shared/errors";
import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { MutateFn, MutationArgs } from "../types";

const useMutationWithHandler = (
  mutationFn: MutateFn,
  { onSuccess, onError, rethrowError = false }: MutationArgs,
  triggerToast = true,
) => {
  const { mutateAsync, ...rest } = useMutation({
    mutationFn,
    onSuccess,
    onError,
  });

  const mutateWithHandler = useCallback(
    async (...args: any[]) => {
      try {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        return await mutateAsync(...args);
      } catch (err: any) {
        triggerToast && metamaskErrorToast(err);

        if (rethrowError) {
          throw err;
        }
      }
    },
    [mutateAsync, rethrowError, triggerToast],
  );

  return {
    mutateAsync: mutateWithHandler,
    onError,
    ...rest,
  };
};

export default useMutationWithHandler;
